<script lang="ts" setup>
const props = defineProps({
  size: {
    type: Number,
    default: 25,
  },
})

const size = computed(() => {
  return `${props.size}px`
})

const widthAndHeight = computed(() => {
  return `${props.size * 2}px`
})

const offset = computed(() => {
  return `${props.size / 5}px`
})
</script>

<template>
  <div class="pause-icon">
    <i class="iconfont icon-triangle-right" />
  </div>
</template>

<style lang="scss" scoped>
.pause-icon {
  width: v-bind(widthAndHeight);
  height: v-bind(widthAndHeight);
  border: 2px solid #FFFFFF;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  > .iconfont {
    font-size: v-bind(size);
    margin-left: v-bind(offset);
  }
}
</style>
